module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Midi-f8304d98d1c7494dbb38c0b3240c2fed.svg";